// Copyright (c) 2021 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import DealershipModalBody from './dealership-modal-body';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import ModalHeader from '../modal-header';
import {WarrantyMediumModal} from '../modal';

const DealershipModal = props =>
    <WarrantyMediumModal
        className='dealership-modal'
        isOpen={props.isModalOpen}
    >
        <ModalHeader
            modalTitle='DEALERSHIP'
            onCloseButtonClick={props.onCloseButtonClick}
        />
        <DealershipModalBody
            laborRateAll={props.laborRateAll}
        />
    </WarrantyMediumModal>;

DealershipModal.displayName = 'DealershipModal';
DealershipModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    laborRateAll: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    onCloseButtonClick: PropTypes.func.isRequired
};

export default DealershipModal;



// WEBPACK FOOTER //
// ./src/shared/components/dealership-detail-modal/dealership-modal.js